import { render } from "./ProposeShop.vue?vue&type=template&id=16718c99&scoped=true"
import script from "./ProposeShop.vue?vue&type=script&lang=js"
export * from "./ProposeShop.vue?vue&type=script&lang=js"

import "./ProposeShop.vue?vue&type=style&index=0&id=16718c99&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-16718c99"]])

export default __exports__